import styled from "styled-components";

export const DraggableListItem = styled.div<{ isDraggingOver?: boolean }>``;
